module.exports = __webpack_public_path__ + "img/2.13a7e86f.gif";